
<app-mcl-wrapper>
<!--    <button (click)="test401()">test401</button>-->
    <app-mcl-header logosource="assets/theme/mclane/img/McLane_logo_wht.png">
        <div class="buttonGroup" *ngIf="this.oauthService.deviceAuthCookieExists(env.buildEnv)">
            <app-menu></app-menu>
        </div>
    </app-mcl-header>
    <div class="headerExInfo">
        <div class="storeGrid">
            <div class="pageTitle">
                <p>{{ pageTitle }}</p>
            </div>
            <div class="store pointer">
                <p [ngClass]="this.storeChangable ? 'store-changeable' : 'store-not-changeable' "
                   (click)="changeSelectedStore(dialog)"
                   id="but-storeQuickChange">{{_storeListService.pickedIdentity}}
                </p>
            </div>
        </div>
    </div>
    <app-mcl-menudrawer class="drawerContainer" [titleHeader]="'Welcome to Mclane SourceLink'">
        <router-outlet (activate)="onActivate($event)"></router-outlet>
    </app-mcl-menudrawer>
    <app-mcl-footer>
        <div class="">
            <p class="cptext">
                © Copyright 2024 McLane Company Incorporated, Temple,TX. All Rights Reserved.
                <br>
                v{{env.version}} ({{env.buildEnv}})
            </p>
        </div>
    </app-mcl-footer>

</app-mcl-wrapper>

<ng-template #user let-item="item">
    <span class="k-icon k-font-icon k-i-user"></span>
    {{item.text}}
</ng-template>

<app-storelist-dialog #dialog></app-storelist-dialog>
<div *ngIf="loadingIndicatorHelper.isLoading | async" class="k-icon k-i-loading"></div>
<div kendoDialogContainer></div>
